import React from 'react';
import LanguageSelection from './LanguageSelection';
import CountrySelection from './CountrySelection';
import PersonalInfo from './PersonalInfo';
import Education from './Education';
import Experience from './Experience';
import LanguageSkills from './LanguageSkills';
import CVUpload from './CVUpload';
import FinancialInfo from './FinancialInfo';
import Review from './Review';
import Submit from './Submit';
import { TOTAL_WIZARD_STEPS } from '../../constants/wizardSteps';

const WizardStepRouter = ({ currentStep, onNext, onPrevious }) => {
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <LanguageSelection
            stepNumber={1}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={false}
          />
        );

      case 2:
        return (
          <CountrySelection
            stepNumber={2}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 3:
        return (
          <PersonalInfo
            stepNumber={3}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 4:
        return (
          <Education
            stepNumber={4}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 5:
        return (
          <Experience
            stepNumber={5}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 6:
        return (
          <LanguageSkills
            stepNumber={6}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 7:
        return (
          <CVUpload
            stepNumber={7}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 8:
        return (
          <FinancialInfo
            stepNumber={8}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 9:
        return (
          <Review
            stepNumber={9}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      case 10:
        return (
          <Submit
            stepNumber={10}
            totalSteps={TOTAL_WIZARD_STEPS}
            onNext={onNext}
            onPrevious={onPrevious}
            canGoPrevious={true}
          />
        );

      default:
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Invalid Step
            </h2>
            <p className="text-gray-600">
              Step {currentStep} is not valid. Please navigate to a valid step.
            </p>
            <button
              onClick={onPrevious}
              className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Go Back
            </button>
          </div>
        );
    }
  };

  return renderStep();
};

export default WizardStepRouter;
